// Module
var code = `<div class="alert alert--danger">
  This process should be executed only once in the branch lifecycle (after data migration).
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branches:</td>
      <td>
        <multiselect
          items="\$ctrl.branches"
          ng-model="\$ctrl.branchIds"
          label-property="'name'"
          value-property="'id'"
          ng-required="true"
          select-all-option="true">
        </multiselect>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/process-start-of-day/process-start-of-day.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;